export const LOW_PRICE_CALENDAR_TEXTS = {
  noPrice: 'Узнать цену',
  pricePrefix: 'от',
  currency: '₽',
} as const;

export const LOW_PRICE_CALENDAR_MONTHS: readonly string[] = [
  'янв',
  'фев',
  'мар',
  'апр',
  'май',
  'июн',
  'июл',
  'авг',
  'сент',
  'окт',
  'нояб',
  'дек',
];

export const LOW_PRICE_CALENDAR_WEEKDAYS: readonly string[] = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'];
